import {
  icons,
  MenuItem,
  sizesIcon,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { ButtonOption } from "../../../model/sponsor";

export const menuItem: MenuItem[] = [
  {
    disabled: false,
    icon: {
      color: "#006ac6",
      icon: icons.Edit,
      size: sizesIcon.standard,
    },
    id: "1",
    name: "Editar",
  },
  {
    disabled: false,
    icon: {
      color: "#006ac6",
      icon: icons.Delete,
      size: sizesIcon.standard,
    },
    id: "2",
    name: "Eliminar",
  },
];
export const buttonActionOptions: ButtonOption[] = [
  {
    icons: icons.Menu,
    id: "1",
    name: "editar",
  },
  {
    icons: icons.Menu,
    id: "2",
    name: "eliminar",
  },
];
export const insurersView = [
  {
    id: "1",
    name: "GridView",
    active: true,
    icon: {
      icon: icons.GridView,
    },
  },
  {
    id: "2",
    name: "List",
    active: false,
    icon: {
      icon: icons.TableRows,
    },
  },
  {
    id: "3",
    name: "tableView",
    active: false,
    icon: {
      icon: icons.TableView,
    },
  },
];

export const statusPermission = [
  {
    id: "1",
    name: "Activo",
    value: "Active",
  },
  {
    id: "2",
    name: "Inactivo",
    value: "Inactive",
  },
];

export const selectValueDefault: string = "name";